import styles from "./UserList.module.css";
import { ReactComponent as Mobile } from "../../../assets/images/cell-phone-svgrepo-com.svg";
import { ReactComponent as Desktop } from "../../../assets/images/desktop-svgrepo-com.svg";
import moment from "moment";
import { NON_ACTIVE_USER_FILTER, ONLINE_USER_FILTER, MOBILE_USER_FILTER } from "../../../config/keys";
import ConfirmationModal, { IButton } from "../../../globals/core/ConfirmationModal/ConfirmationModal";
import { useState } from "react";
interface IParticipant {
  email: string;
  firstName: string;
  lastName: string;
  role: string; //TODO enum Member | Administrator
  status: string;
  _id: string;
  socketSession?: any; //TODO
  mobileDeviceId?: any; //TODO
  termsApproveDate?: string;
}

interface IUserList {
  participants: IParticipant[];
  onFilterParticipants: (filter: string) => void;
  onRemoveParticipant: (participants: IParticipant) => void;
  onResetParticipants: () => void;
}

const UserList = ({ participants, onRemoveParticipant, onFilterParticipants, onResetParticipants }: IUserList) => {
  const [confirmationModal, setConfirmationModal] = useState<{ open: boolean; title?: string; message?: string; buttons?: IButton[] }>({
    open: false,
    title: "",
    message: "",
    buttons: [],
  });

  const listItems = participants.map((participant) => (
    <div className={styles.participantRecord} key={participant?._id.toString()}>
      <div className={styles.participantCol}>{participant?.socketSession ? <div className={styles.OnlineUser}></div> : <div className={styles.OfflineUser}></div>}</div>
      <div className={styles.participantCol}>{participant?.mobileDeviceId ? <Mobile /> : <Desktop />}</div>
      <div className={styles.participantRecordName}>
        {participant?.firstName} {participant?.lastName}
      </div>
      <div className={styles.participantRecordTerms}>{participant?.termsApproveDate && moment(participant?.termsApproveDate).format("MM/DD/YYYY")}</div>
      <div className={styles.removeParticipantFromSenderList} onClick={() => onRemove(participant)}>
        X
      </div>
    </div>
  ));

  const onRemove = (participant: IParticipant): void => {
    setConfirmationModal({
      open: true,
      title: "Remove Participant",
      message: `Are you sure you want to remove ${participant?.firstName} ${participant?.lastName}?`,
      buttons: [
        {
          label: "Cancel",
          style: "info",
          loading: false,
          onClick: () => setConfirmationModal({ open: false }),
        },
        {
          label: "Yes, Remove",
          style: "error",
          loading: false,
          onClick: () => {
            onRemoveParticipant(participant);
            setConfirmationModal({ open: false });
          },
        },
      ],
    });
  };

  return (
    <>
      <div className={styles.container}>
        <div>User List</div>
        <div className={styles.filterContainer}>
          <div className={styles.filterBtn} onClick={() => onResetParticipants()}>
            Refresh
          </div>
          <div className={styles.filterBtn} onClick={() => onFilterParticipants(NON_ACTIVE_USER_FILTER)}>
            Non Active
          </div>
          <div className={styles.filterBtn} onClick={() => onFilterParticipants(ONLINE_USER_FILTER)}>
            Online
          </div>
          <div className={styles.filterBtn} onClick={() => onFilterParticipants(MOBILE_USER_FILTER)}>
            Mobile
          </div>
        </div>
        <div className={styles.participantListContainer}>
          <div className={styles.participantRecord}>
            <div className="">
              <div className={styles.OnlineUser}></div>
            </div>
            <div> </div>
            <div className={styles.bold}>Full Name</div>
            <div className={styles.bold}>Terms Date</div>
            <div> </div>
          </div>
          {participants.length > 0 ? listItems : <div className={styles.noParticipants}>No participants</div>}
        </div>
      </div>
      <ConfirmationModal {...confirmationModal} onClose={() => setConfirmationModal({ open: false })} />
    </>
  );
};

export default UserList;
